
export interface StoryCategory {
  title: string;
  slug: string;
  description: string;
  featured?: boolean;
}

export const storyCategories: StoryCategory[] = [{
  title: "Interiors",
  slug: "interior-design",
  description: "Aesthetic meets function",
  featured: false
}, {
  title: "Architecture",
  slug: "architecture",
  description: "Design beyond boundaries",
  featured: true
}, {
  title: "Minimalism",
  slug: "minimalism",
  description: "The power of less",
  featured: true
}, {
  title: "Eclectic",
  slug: "eclectic",
  description: "Style without rules",
  featured: true
}, {
  title: "Considered",
  slug: "considered",
  description: "Intentional, sustainable design",
  featured: false
}, {
  title: "Editor's Picks",
  slug: "editors-picks",
  description: "Our top choices",
  featured: false
}, {
  title: "Houses on Screen",
  slug: "houses-on-screen",
  description: "Homes made famous",
  featured: false
}, {
  title: "Studios",
  slug: "studios",
  description: "Where ideas are born",
  featured: false
}, {
  title: "Cars of Everhouse",
  slug: "cars-of-everhouse",
  description: "Automotive design and engineering excellence",
  featured: false
}, {
  title: "All",
  slug: "all",
  description: "Everything in one place",
  featured: false
}];
